<section class="promo" data-testid="promotions-panel">
  <header class="promo__header">
    <div>
      <h3 class="promo__title">Propostas de conta oficial</h3>
      <p class="promo__subtitle">
        Subcontas criadas nas empresas que se repetem (5 empresas ou mais) ou pesam no grupo (5% ou
        mais) viram candidatas a conta do plano padrão.
      </p>
    </div>
    <app-button
      [label]="'Atualizar'"
      [icon]="'pi pi-refresh'"
      [theme]="'white'"
      [type]="'button'"
      [disabled]="isLoading()"
      (sendButtonClick)="load()" />
  </header>

  <p class="promo__notice">
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <span>
      Aceitar cria a conta nova no plano padrão, como filha da conta pai, e reclassifica para ela as linhas
      das subcontas das empresas. Recusar só registra a decisão, com o motivo.
    </span>
  </p>

  @if (isLoading()) {
    <div class="promo__loading">
      <app-cog-loading-spinner [size]="64" />
    </div>
  } @else if (errorMessage(); as message) {
    <p class="promo__error" role="alert">{{ message }}</p>
  } @else if (proposals().length === 0) {
    <p class="promo__empty" data-testid="promotions-empty">
      Nenhuma proposta no momento. Elas aparecem quando a mesma subconta se repete entre empresas ou
      ganha peso no grupo.
    </p>
  } @else {
    <div class="promo__body">
      <div class="promo__list" role="list">
        <div class="promo__item promo__item--head" role="listitem">
          <span>Nome</span>
          <span>Conta pai</span>
          <span>Empresas</span>
          <span>Maior peso</span>
          <span>Situação</span>
        </div>
        @for (proposal of proposals(); track proposal.id) {
          <button
            type="button"
            role="listitem"
            class="promo__item"
            [class.promo__item--active]="selectedId() === proposal.id"
            data-testid="promotion-item"
            (click)="select(proposal.id)">
            <span class="promo__name">{{ proposal.name }}</span>
            <span>{{ proposal.parentStandardAccountLabel ?? '—' }}</span>
            <span>{{ proposal.companyCount }}</span>
            <span>{{ formatShare(proposal.maxGroupShare) }}</span>
            <span class="promo__status" [attr.data-status]="proposal.status">
              {{ statusLabel(proposal.status) }}
            </span>
          </button>
        }
      </div>

      @if (selected(); as proposal) {
        <article class="promo__detail" data-testid="promotion-detail">
          <h4 class="promo__detail-title">{{ proposal.name }}</h4>
          <p class="promo__detail-meta">
            Sob {{ proposal.parentStandardAccountLabel ?? 'a conta pai' }} ·
            {{ proposal.statementType === 'Dre' ? 'DRE' : 'Balanço' }} ·
            {{ proposal.companyCount }}
            {{ proposal.companyCount === 1 ? 'empresa' : 'empresas' }} · maior peso no grupo
            {{ formatShare(proposal.maxGroupShare) }}
          </p>

          @if (draftHtml(); as html) {
            <div class="promo__draft" [innerHTML]="html"></div>
          } @else {
            <p class="promo__empty">
              O rascunho ainda não foi redigido pelo Cog. A decisão pode esperar por ele.
            </p>
          }

          @if (proposal.status === 'Accepted' || proposal.status === 'Rejected') {
            <p class="promo__decided">
              {{ statusLabel(proposal.status) }}
              @if (proposal.decidedByUserName) {
                por {{ proposal.decidedByUserName }}
              }
              @if (proposal.decidedAt) {
                em {{ proposal.decidedAt | vaultDateTime }}
              }
              @if (proposal.decisionReason) {
                : "{{ proposal.decisionReason }}"
              }
            </p>
            @if (proposal.status === 'Accepted' && proposal.standardSubAccountId) {
              <p class="promo__decided" data-testid="promotion-reclassification">
                @if (proposal.reclassifiedAt) {
                  Conta oficial criada. {{ proposal.reclassifiedLineCount ?? 0 }} linha(s) das empresas
                  reclassificada(s) em {{ proposal.reclassifiedAt | vaultDateTime }}.
                } @else {
                  Conta oficial criada. A reclassificação das linhas ainda tem pendência
                  ({{ proposal.reclassifiedLineCount ?? 0 }} linha(s) movida(s) até agora); a rotina semanal
                  retoma sozinha.
                }
              </p>
              @if (!proposal.reclassifiedAt && canReclassify()) {
                <div class="promo__actions">
                  <app-button
                    [label]="'Reclassificar de novo'"
                    [theme]="'white'"
                    [type]="'button'"
                    [disabled]="isReclassifying()"
                    [isLoading]="isReclassifying()"
                    [loadingText]="'Reclassificando...'"
                    data-testid="promotion-reclassify"
                    (sendButtonClick)="reclassify()" />
                </div>
              }
            }
          } @else if (canDecide()) {
            <div class="promo__decision">
              <app-input
                [type]="'textarea'"
                [label]="'Motivo da decisão'"
                [placeholder]="'Por que aceitar ou recusar esta conta no plano padrão'"
                [required]="true"
                [textCenter]="false"
                [maxLength]="reasonMaxLength"
                [ngModel]="reason()"
                (ngModelChange)="reason.set($event ?? '')"
                data-testid="promotion-reason" />
              <div class="promo__actions">
                <app-button
                  [label]="'Recusar'"
                  [theme]="'white'"
                  [type]="'button'"
                  [disabled]="!canSubmitDecision()"
                  data-testid="promotion-reject"
                  (sendButtonClick)="decide(false)" />
                <app-button
                  [label]="'Aceitar'"
                  [theme]="'default'"
                  [type]="'button'"
                  [disabled]="!canSubmitDecision()"
                  [isLoading]="isDeciding()"
                  [loadingText]="'Registrando...'"
                  data-testid="promotion-accept"
                  (sendButtonClick)="decide(true)" />
              </div>
            </div>
          } @else {
            <p class="promo__readonly">
              Você pode ver as propostas, mas decidir exige a permissão de decidir propostas de
              conta.
            </p>
          }
        </article>
      }
    </div>
  }
</section>
